import React from "react"
import { useTable, useSortBy, usePagination, useFilters, useGlobalFilter } from "react-table"
import { SearchIcon } from "components/Elements/Icons"
import { TableHeader, TableBody } from "."

const PAGINATION_LENGTH = 10

export const Table = ({
	columns,
	data,
	specificSortBy = [],
	isSortable = true,
	className = "",
	rowClassName = "flex-row",
	hasSearchBar = true,
	isPaginable = false,
	pageSize = PAGINATION_LENGTH,
	searchPlaceholder = "",
}) => {
	const sortBy = isSortable ? useSortBy : () => {}
	const tableInstance = useTable(
		{
			columns,
			data,
			initialState: {
				sortBy: specificSortBy,
				pageSize: pageSize,
			},
		},
		useFilters,
		useGlobalFilter,
		sortBy,
		useSortBy,
		usePagination
	)

	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		prepareRow,
		rows, // the rows for the active page is isPaginable = false
		page, // the rows for the active page is isPaginable = true

		// pagination utilities
		canPreviousPage,
		canNextPage,
		pageOptions,
		pageCount,
		gotoPage,
		setGlobalFilter,
		state: { pageIndex },
	} = tableInstance

	// Manage global search
	// -------------------
	const [dataTableFilter, setDataTableFilter] = React.useState("")
	React.useEffect(() => setGlobalFilter(dataTableFilter), [dataTableFilter, setGlobalFilter])

	// Manage pagination
	// -------------------
	const middleDistance = Math.round((pageSize - 1) / 2)
	const pageShouldBeHiddenInPagination = (index) => {
		// in the first pages,
		// pagination should not exceed pageSize
		const condition1 = pageIndex <= middleDistance && index > pageSize - 1
		// in the middle pages,
		// show x pages before currentPage and y pages after currentPage
		const condition2 =
			pageIndex > middleDistance &&
			pageIndex < pageOptions.length - middleDistance &&
			(index < pageIndex - middleDistance || index > pageIndex + middleDistance - 1)
		// in the last pages,
		// always show the x last pages
		const condition3 =
			pageIndex > pageOptions.length - 1 - middleDistance &&
			index < pageOptions.length - pageSize
		return condition1 || condition2 || condition3
	}

	return (
		<>
			<div className={"c-form-group c-form-group--picto mb-7"}>
				{hasSearchBar && (
					<>
						<SearchIcon size={25} className="c-input-picto" />
						<input
							className={"c-input pl-12"}
							id={"tableglobalFilter"}
							name={"tableglobalFilter"}
							type={"text"}
							placeholder={searchPlaceholder}
							value={dataTableFilter}
							style={{ maxWidth: "400px" }}
							onChange={(event) => setDataTableFilter(event.target.value)}
						/>
					</>
				)}
			</div>
			<table className={`c-table c-table--responsive ${className}`} {...getTableProps()}>
				<TableHeader headerGroups={headerGroups} isSortable={isSortable} />
				<TableBody
					getTableBodyProps={getTableBodyProps}
					rows={isPaginable ? page : rows}
					prepareRow={prepareRow}
					rowClassName={rowClassName}
				/>

				{/* Pagination */}
				{isPaginable && pageOptions && pageOptions.length > 1 && (
					<div>
						<div className="c-pagination flex justify-center flex-row pt-7">
							<button
								type="button"
								className="c-btn c-btn--primary u-mg-hz-l"
								onClick={() => gotoPage(0)}
								disabled={!canPreviousPage}
							>
								{"<<"}
							</button>
							{pageOptions.map((index) => {
								if (pageShouldBeHiddenInPagination(index))
									return <React.Fragment key={index}></React.Fragment>
								return (
									<button
										type="button"
										key={index}
										className={index === pageIndex ? "font-bold px-5" : "px-5"}
										// style={{ width: '30px' }}
										onClick={() => gotoPage(index)}
									>
										{index + 1}
									</button>
								)
							})}
							<button
								type="button"
								className="c-btn c-btn--primary u-mg-hz-l"
								onClick={() => gotoPage(pageCount - 1)}
								disabled={!canNextPage}
							>
								{">>"}
							</button>
						</div>
					</div>
				)}
			</table>
		</>
	)
}
